import type { HTMLReactParserOptions } from "html-react-parser";
import parse from "html-react-parser";

export const useHtmlParser = () => {
  const mapToReactComponents = (annotatedMarkup: string, options: HTMLReactParserOptions) => {
    return parse(annotatedMarkup, options);
  };

  return {
    mapToReactComponents,
  };
};
